export default __webpack_public_path__ + "static/media/ExaminationIcon.b4963e66.svg";